import { render, staticRenderFns } from "./CommodityListLayout.vue?vue&type=template&id=7270067c&scoped=true"
import script from "./CommodityListLayout.vue?vue&type=script&lang=js"
export * from "./CommodityListLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7270067c",
  null
  
)

export default component.exports